/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthIntegration } from './PalAuthIntegration';
import {
    PalAuthIntegrationFromJSON,
    PalAuthIntegrationFromJSONTyped,
    PalAuthIntegrationToJSON,
} from './PalAuthIntegration';

/**
 * 
 * @export
 * @interface LeadPalInfo
 */
export interface LeadPalInfo {
    /**
     * 
     * @type {boolean}
     * @memberof LeadPalInfo
     */
    execution_available: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeadPalInfo
     */
    oon_execution_available?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeadPalInfo
     */
    oon_auto_submission_available?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    execution_available_reason: LeadPalInfoExecutionAvailableReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    payor_id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    insurance_type: LeadPalInfoInsuranceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    latest_execution_state: LeadPalInfoLatestExecutionStateEnum;
    /**
     * 
     * @type {Array<PalAuthIntegration>}
     * @memberof LeadPalInfo
     */
    auth_platform_integrations?: Array<PalAuthIntegration>;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    latest_execution_created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    latest_submission_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    latest_submission_status?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    latest_submission_created_at?: string;
    /**
     * The facility's active dedicated eFax inbox number, if configured. Null when eFax submissions for this facility would be sent from the shared/generic exacare fax number. Preview of the sender number resolved at actual send time — see PalAuthSubmission's sender_fax_number for what was actually used on a submission.
     * @type {string}
     * @memberof LeadPalInfo
     */
    efax_sender_fax_number?: string;
}


/**
 * @export
 */
export const LeadPalInfoExecutionAvailableReasonEnum = {
    LeadAnalysisInProgress: 'lead_analysis_in_progress',
    NoPrimaryCommercialInsurance: 'no_primary_commercial_insurance',
    NoContractStored: 'no_contract_stored',
    PayorNotSupported: 'payor_not_supported',
    QuotaExceeded: 'quota_exceeded',
    Null: 'null'
} as const;
export type LeadPalInfoExecutionAvailableReasonEnum = typeof LeadPalInfoExecutionAvailableReasonEnum[keyof typeof LeadPalInfoExecutionAvailableReasonEnum];

/**
 * @export
 */
export const LeadPalInfoInsuranceTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
    Null: 'null'
} as const;
export type LeadPalInfoInsuranceTypeEnum = typeof LeadPalInfoInsuranceTypeEnum[keyof typeof LeadPalInfoInsuranceTypeEnum];

/**
 * @export
 */
export const LeadPalInfoLatestExecutionStateEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished',
    Null: 'null'
} as const;
export type LeadPalInfoLatestExecutionStateEnum = typeof LeadPalInfoLatestExecutionStateEnum[keyof typeof LeadPalInfoLatestExecutionStateEnum];


/**
 * Check if a given object implements the LeadPalInfo interface.
 */
export function instanceOfLeadPalInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "execution_available" in value;
    isInstance = isInstance && "execution_available_reason" in value;
    isInstance = isInstance && "payor_id" in value;
    isInstance = isInstance && "insurance_type" in value;
    isInstance = isInstance && "latest_execution_state" in value;

    return isInstance;
}

export function LeadPalInfoFromJSON(json: any): LeadPalInfo {
    return LeadPalInfoFromJSONTyped(json, false);
}

export function LeadPalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadPalInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'execution_available': json['execution_available'],
        'oon_execution_available': !exists(json, 'oon_execution_available') ? undefined : json['oon_execution_available'],
        'oon_auto_submission_available': !exists(json, 'oon_auto_submission_available') ? undefined : json['oon_auto_submission_available'],
        'execution_available_reason': json['execution_available_reason'],
        'payor_id': json['payor_id'],
        'insurance_type': json['insurance_type'],
        'latest_execution_state': json['latest_execution_state'],
        'auth_platform_integrations': !exists(json, 'auth_platform_integrations') ? undefined : ((json['auth_platform_integrations'] as Array<any>).map(PalAuthIntegrationFromJSON)),
        'latest_execution_created_at': !exists(json, 'latest_execution_created_at') ? undefined : json['latest_execution_created_at'],
        'latest_submission_id': !exists(json, 'latest_submission_id') ? undefined : json['latest_submission_id'],
        'latest_submission_status': !exists(json, 'latest_submission_status') ? undefined : json['latest_submission_status'],
        'latest_submission_created_at': !exists(json, 'latest_submission_created_at') ? undefined : json['latest_submission_created_at'],
        'efax_sender_fax_number': !exists(json, 'efax_sender_fax_number') ? undefined : json['efax_sender_fax_number'],
    };
}

export function LeadPalInfoToJSON(value?: LeadPalInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'execution_available': value.execution_available,
        'oon_execution_available': value.oon_execution_available,
        'oon_auto_submission_available': value.oon_auto_submission_available,
        'execution_available_reason': value.execution_available_reason,
        'payor_id': value.payor_id,
        'insurance_type': value.insurance_type,
        'latest_execution_state': value.latest_execution_state,
        'auth_platform_integrations': value.auth_platform_integrations === undefined ? undefined : ((value.auth_platform_integrations as Array<any>).map(PalAuthIntegrationToJSON)),
        'latest_execution_created_at': value.latest_execution_created_at,
        'latest_submission_id': value.latest_submission_id,
        'latest_submission_status': value.latest_submission_status,
        'latest_submission_created_at': value.latest_submission_created_at,
        'efax_sender_fax_number': value.efax_sender_fax_number,
    };
}

